<template>
  <text-input
    :fixed-placeholder="false"
    :autocomplete="autocomplete"
    :has-bar="hasBar"
    :autofocus="autofocus"
    v-bind="updatedProps"
    v-on="updatedListeners"
  />
</template>
<script>
import { format, isValid, parseISO } from 'date-fns'

import TextInput from './TextInput'

const formatDate = (input, dateFormat = 'dd.MM.yyyy') => {
  if (!input) return
  if (input.includes('.')) {
    input = `${input.substr(6, 4)}-${input.substr(3, 2)}-${input.substr(0, 2)}`
  }

  const parsed = parseISO(input)
  return isValid(parsed) ? format(parsed, dateFormat) : null
}

export default {
  name: 'DateInput',

  components: {
    TextInput,
  },

  extends: TextInput,

  props: {
    hasNativeDatepicker: {
      type: Boolean,
      default: false,
    },

    hasBar: {
      type: Boolean,
      default: true,
    },

    autocomplete: {
      type: String,
      default: 'do-not-auto-complete',
    },

    min: {
      type: String,
      default: '',
    },
    max: {
      type: String,
      default: '',
    },
  },

  computed: {
    isMobileViewport() {
      return !this.$mq['md!']
    },

    useNativeDatePicker() {
      return this.hasNativeDatepicker && !this.isMobileViewport
    },

    /*  FLEX-1229
        Desktop: Use native datepicker for desktop if hasNativeDatepicker set to true
        Mobile:  Use inputmode decimal
     */
    inputConfig() {
      const manualInput = {
        mask: '##.##.####',
        inputmode: 'decimal',
        placeholder: this.placeholder ?? 'DD.MM.YYYY', // provide some default values for inherited properties that have not been passed
      }
      const nativeDateInput = {
        type: 'date',
        mask: '',
        placeholder: '', // native picker shows it's own placeholder
        isTouched: true, // moves the title up, for use with native placeholder
      }

      // native datepicker only for desktop
      return this.useNativeDatePicker ? nativeDateInput : manualInput
    },

    updatedProps() {
      // value: if value is a date (most likely), we try to format it in a human readable way (if not using native date picker)
      const value =
        !this.useNativeDatePicker && this.value && this.value.length === 10
          ? formatDate(this.value)
          : this.value

      //  otherwise we pass it as is to the TextInput component.
      // v-mask: we force the format to a date
      return Object.assign({}, this.$props, this.inputConfig, { value })
    },

    updatedListeners() {
      const vm = this
      return Object.assign({}, this.$listeners, {
        input(value) {
          // if emitted value is a complete date, we try to reformat it in a iso way
          if (value && value.length === 10) {
            value = formatDate(value, 'yyyy-MM-dd')
          }
          vm.$emit('input', value)
        },
        blur(value) {
          // if emitted value is a complete date, we try to reformat it in a iso way
          if (value && value.length === 10) {
            value = formatDate(value, 'yyyy-MM-dd')
          }
          vm.$emit('blur', value)
        },
      })
    },
  },
}
</script>
